import { render, staticRenderFns } from "./TransactionsDetails.vue?vue&type=template&id=08b19c60&"
import script from "./TransactionsDetails.vue?vue&type=script&lang=js&"
export * from "./TransactionsDetails.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports